import React, { Component } from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import UserLinks from '../Accessories/UserLinks'
import { FaPhone } from 'react-icons/lib/fa'

const iconStyle = {
  width: '40px',
  height: '40px',
  color: '#5CEA83'
}

class FooterComponent extends Component {
  render() {
    const { config } = this.props
    const url = config.siteRss
    const copyright = config.copyright

    return (
      <FooterContainer>
        <FooterGrid>
          <CtaContainer>
            <FaPhone style={iconStyle} />
            <p>
              If you're looking for more information, don't hesitate to get in
              touch.
            </p>
            <Link to={'/contact'}>Contact →</Link>
          </CtaContainer>
          <MenuContainer>
            <div className="to-center">
              <h3>Discover</h3>
              <Link to={'/'}>Home</Link>
              <Link to={'/blog'}>Blog</Link>
              <Link to={'/jobs'}>Careers</Link>
              <Link to={'/contact'}>Contact</Link>
            </div>
          </MenuContainer>
          <FollowContainer>
            <h3 className="mobile-hide">Follow AppTree</h3>
            <UserLinks config={config} labeled />
          </FollowContainer>
          <BottomRow>
            <div className="Left">
              <Link to={'/terms-of-service'}>Terms of Service</Link>
              <a href={'/privacy/'} target="blank">
                Privacy Policy
              </a>
            </div>
            <div className="Right">
              <p>{copyright}</p>
              <p>
                <a href="http://ericwindmill.com">Site by Eric Windmill</a>
              </p>
            </div>
          </BottomRow>
        </FooterGrid>
      </FooterContainer>
    )
  }
}

export default FooterComponent

const FooterContainer = styled.footer`
  background: #171717;
  padding-top: 30px;
  height: 100%;
`

const FooterGrid = styled.div`
  max-width: 900px;
  margin: auto;
  display: grid;
  grid-template-columns: repeat(3, 33.333333333333%);
  grid-template-rows: 1fr 60px;
  grid-template-areas: 'cta links follow' 'bottom bottom bottom';
  grid-column-gap: 30px;

  @media screen and (max-width: 768px) {
    width: 100%;
    grid-template-columns: 100%;
    grid-template-rows: repeat(4, 100%);
    grid-template-areas: 'cta' 'links' 'follow' 'bottom';
    justify-content: start;
    grid-gap: 10px;
  }

  & * {
    color: #b7b8c9;
    font-size: 1.4rem;
    font-weight: 100;
  }

  & h3 {
    color: white;
    font-weight: 500;
    font-size: 2rem;
    line-height: 2;
    padding-bottom: 15px;
  }

  & > div {
    padding: 30px 0;

    @media screen and (max-width: 768px) {
      padding: 15px;
    }
  }
`

const CtaContainer = styled.div`
  grid-area: cta;
  display: grid;
  grid-template-columns: 1fr;
  grid-row-gap: 10px;

  @media screen and (max-width: 768px) {
    margin: auto;
    width: 80%;
  }

  & p {
    max-width: 250px;
    @media screen and (max-width: 768px) {
      max-width: 100%;
    }
  }

  & a {
    text-decoration: none;
    font-size: 1.8rem;
    line-height: 1.5;
    font-weight: 600;
    color: white;
    transition: all ease 300ms;

    &:hover {
      color: white;
    }
  }
`

const MenuContainer = styled.div`
  grid-area: links;
  .to-center {
    display: flex;
    flex-direction: column;
    width: 150px;
    margin: auto;
  }

  @media screen and (max-width: 768px) {
    display: none;
    .to-center {
      display: grid;
      grid-template-columns: repeat(2, 50%);
      width: 80%;
      margin: auto;
    }
  }

  & a {
    text-decoration: none;
    font-size: 1.4rem;
    line-height: 1.6;
    font-weight: 100;
    transition: all ease 300ms;

    &:hover {
      color: white;
    }
  }
`

const FollowContainer = styled.div`
  grid-area: follow;

  @media screen and (max-width: 768px) {
    margin: auto;
    .mobile-hide {
      display: none;
    }
  }
  & svg {
    transition: all ease 300ms;
  }

  & svg:hover {
    color: white;
  }
`

const BottomRow = styled.div`
  padding: 20px 0 !important;
  border-top: 0.5px solid #b7b8c9;
  grid-area: bottom;
  text-align: right;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 768px) {
    display: grid;
    grid-template-columns: 50% 50%;
  }

  & * {
    font-size: 1.4rem;
    font-weight: 100;
  }

  .Left {
    display: grid;
    grid-template-columns: 150px 150px;
    justify-items: start;

    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
      margin-left: 30px;
      align-items: center;
    }

    & > a:hover {
      color: white;
    }
  }

  .Right {
    display: grid;
    grid-template-columns: 200px 150px;
    justify-items: start;

    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
      grid-template-rows: 50px 50px;
      align-items: center;
    }

    & > p a:hover {
      color: white;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Layout/Footer.jsx